var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDarkNotes(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame",
    clipPath: "url(#clip0_677_56403)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 427321065"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.33333 4.16797H5.66667C5.22464 4.16797 4.80072 4.34356 4.48816 4.65612C4.17559 4.96868 4 5.39261 4 5.83464V15.8346C4 16.2767 4.17559 16.7006 4.48816 17.0131C4.80072 17.3257 5.22464 17.5013 5.66667 17.5013H10.667",
    stroke: "blue",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M12.3337 4.16797H14.0003C14.4424 4.16797 14.8663 4.34356 15.1788 4.65612C15.4914 4.96868 15.667 5.39261 15.667 5.83464V15.8346C15.667 16.2767 15.4914 16.7006 15.1788 17.0131C14.8663 17.3257 14.4424 17.5013 14.0003 17.5013H9",
    stroke: "blue",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M10.6673 2.5H9.00065C8.08018 2.5 7.33398 3.24619 7.33398 4.16667C7.33398 5.08714 8.08018 5.83333 9.00065 5.83333H10.6673C11.5878 5.83333 12.334 5.08714 12.334 4.16667C12.334 3.24619 11.5878 2.5 10.6673 2.5Z",
    stroke: "blue",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M7.33398 10H12.6673",
    stroke: "blue",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M7.33398 13.332H11.834",
    stroke: "blue",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_677_56403"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkNotes);
export default __webpack_public_path__ + "static/media/darkNotes.24c42b09677182dd60307c6ddcfb16ae.svg";
export { ForwardRef as ReactComponent };